/* Home card fan (sections/chumzy-card-fan.liquid). Motion copied from design/trend-look/card-fan-home.html.
   PC: stack -> fan when the pointer enters -> hovered card pops forward, the rest glide aside. Phone / touch: tap to spread. */
(() => {
  const wide = matchMedia('(hover: hover) and (min-width: 768px)');
  const still = matchMedia('(prefers-reduced-motion: reduce)');

  // The newest card sits in the middle, older ones alternate outward (0->0, 1->-1, 2->+1, 3->-2 ...)
  const slot = (i) => (i === 0 ? 0 : i % 2 ? -(i + 1) / 2 : i / 2);
  const put = (el, x, y, r, s, z) => {
    el.style.transform = `translate(${x}px, ${y}px) rotate(${r}deg) scale(${s})`;
    el.style.zIndex = z;
  };
  const stackPose = (i) => {
    const k = slot(i);
    return { x: k * 26, y: Math.abs(k) * 6, r: k * 4.5 };
  };

  function init(root) {
    if (root.dataset.czReady) return;
    root.dataset.czReady = '1';
    const deck = root.querySelector('[data-cz-deck]');
    const hint = root.querySelector('[data-cz-hint]');
    const cards = [...deck.querySelectorAll('.cz-fan__card')];
    const n = cards.length;
    if (!n) return;
    let mode = '';
    let state = 'stack';
    let focus = -1;
    let leaveTimer = 0;

    function layoutPc() {
      const w = cards[0].offsetWidth;
      const room = deck.clientWidth - w - 40;
      const step = Math.max(60, Math.min(w * 0.74, room / Math.max(1, n - 1)));
      cards.forEach((el, i) => {
        const k = slot(i);
        const z = 50 - Math.abs(k) * 2;
        el.classList.toggle('is-focus', state === 'focus' && i === focus);
        el.classList.toggle('is-dim', state === 'focus' && i !== focus);
        if (state === 'stack') {
          const p = stackPose(i);
          return put(el, p.x, p.y, p.r, 1, z);
        }
        if (state === 'spread') return put(el, k * step, Math.abs(k) * 10, k * 3, 0.94, z);
        const kf = slot(focus);
        if (i === focus) return put(el, kf * step, -26, 0, 1.3, 100);
        const side = Math.sign(k - kf);
        put(el, k * step * 0.86 + side * w * 0.42, 22, k * 4, 0.8, z - Math.abs(k - kf));
      });
    }

    function setMode() {
      const next = wide.matches ? 'pc' : 'm';
      if (next === mode) return mode === 'pc' && layoutPc();
      mode = next;
      root.classList.toggle('is-m', mode === 'm');
      deck.classList.remove('is-open');
      deck.scrollLeft = 0;
      cards.forEach((el) => {
        el.style.transition = '';
      });
      focus = -1;
      state = mode === 'pc' && still.matches ? 'spread' : 'stack';
      if (mode === 'pc') return layoutPc();
      cards.forEach((el, i) => {
        const p = stackPose(i);
        el.classList.remove('is-focus', 'is-dim');
        put(el, p.x * 0.7, p.y, p.r, 1, 50 - Math.abs(slot(i)) * 2);
      });
      if (hint) hint.textContent = hint.dataset.open;
    }

    deck.addEventListener('pointerover', (e) => {
      if (mode !== 'pc' || e.pointerType === 'touch') return;
      clearTimeout(leaveTimer);
      const el = e.target.closest('.cz-fan__card');
      if (el) {
        state = 'focus';
        focus = cards.indexOf(el);
      } else if (state === 'stack') state = 'spread';
      layoutPc();
    });
    deck.addEventListener('pointerleave', () => {
      if (mode !== 'pc') return;
      leaveTimer = setTimeout(() => {
        state = still.matches ? 'spread' : 'stack';
        focus = -1;
        layoutPc();
      }, 500);
    });
    cards.forEach((el, i) =>
      el.addEventListener('focus', () => {
        if (mode !== 'pc') return;
        state = 'focus';
        focus = i;
        layoutPc();
      })
    );

    // Phone: FLIP from the stacked spots to the row spots
    function flip(open) {
      const before = cards.map((el) => ({ x: el.offsetLeft - deck.scrollLeft, y: el.offsetTop, t: el.style.transform }));
      deck.classList.toggle('is-open', open);
      if (!open) deck.scrollLeft = 0;
      cards.forEach((el, i) => {
        const a = before[i];
        const bx = el.offsetLeft - deck.scrollLeft;
        const by = el.offsetTop;
        const p = stackPose(i);
        const end = open ? 'none' : `translate(${p.x * 0.7}px, ${p.y}px) rotate(${p.r}deg)`;
        if (still.matches) {
          el.style.transition = 'none';
          el.style.transform = end;
          return;
        }
        el.style.transition = 'none';
        el.style.transform = `translate(${a.x - bx}px, ${a.y - by}px) ${open ? a.t.replace(/translate\([^)]*\)/, '') : ''}`;
        el.getBoundingClientRect();
        el.style.transition = `transform .6s var(--pop) ${open ? i * 0.035 : 0}s`;
        el.style.transform = end;
      });
      if (hint) hint.textContent = open ? hint.dataset.close : hint.dataset.open;
    }
    deck.addEventListener('click', (e) => {
      if (mode !== 'm' || deck.classList.contains('is-open')) return;
      e.preventDefault();
      flip(true);
    });
    if (hint) hint.addEventListener('click', () => flip(!deck.classList.contains('is-open')));

    wide.addEventListener('change', setMode);
    addEventListener('resize', () => mode === 'pc' && layoutPc());
    setMode();
  }

  const boot = (scope) => scope.querySelectorAll('[data-cz-fan]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
